import React from "react";
import './selectInput.scss';

const SelectInput = ({
  label,
  required, 
  name,
  placeholder = "Select an option",
  register = () => {},
  errors = {},
  children,
  className='',
  ...rest
}) => {
  return (
    <div className={`input-container ${className}`}>
      <label htmlFor={name} className="input-label">
        {label} {required && <span className="required">*</span>}
      </label>

      <div className="select-wrapper">
        <select
          className={`select-field ${errors[name] ? "select-error" : ""}`}
          {...register(name)}
          {...rest}
        >
          <option value="" disabled hidden className="dd-placeholder">{placeholder}</option>
          {children}
        </select>
      </div>
      {errors[name] && (
        <div className="error-message">Invalid Value</div>
      )}
    </div>
  );
};

export default SelectInput;

